import { useState } from "react";
import { useCreateProductServiceAdminAxiosInstance } from "../../Auth/useCreateProductServiceAdminAxiosInstance.ts";
import { BonificoOrderDTO, BonificoOrderStatus } from "./BonificoOrderDTO.ts";

export function useSetBonificoOrderStatus() {
  const { createAxiosInstance } = useCreateProductServiceAdminAxiosInstance();
  const [loading, setLoading] = useState(false);

  const setStatus = async (
    orderId: string,
    status: BonificoOrderStatus,
  ): Promise<BonificoOrderDTO> => {
    setLoading(true);
    try {
      const { data } = await createAxiosInstance().post<BonificoOrderDTO>(
        `/bonifico-orders/${orderId}/status`,
        { status },
      );
      return data;
    } finally {
      setLoading(false);
    }
  };

  return { setStatus, loading };
}
